export function generateFilename(items: Array<string | number>, ext: string) {
  const filename = [...items]
    .filter((item) => Boolean(item))
    .map((item) => String(item).split(' ').join('-'))
    .join('-');

  return `${filename}.${ext}`;
}
